import React from "react";

const MastWallNone = ({ column, gridScale, colorList, luminaires }) => {
    const { height = 6, tilt, point, positionAngle } = column.values;
    const { x, y } = point;
    const columnBaseZ = (height * gridScale) / 2;
    const defaultBaseColor = "lightgray";

    const { lanterns = [] } = column.values;
    const getOutreachWidth = (lantern) => {
        const useLanternOutreach = column.values.useLanternOutreach;
        const value = useLanternOutreach && lantern?.outreach != null
            ? lantern.outreach
            : column.values.outreach || 0.75;
        return 0.75 * value;
    };

    const offsets = lanterns.map(l => parseFloat(l.offset) || 0);
    let width = 0.4;
    let centerOffset = 0;
    let adjustedX = x;

    if (offsets.length === 1) {
        centerOffset = offsets[0];
        adjustedX = x + centerOffset;
    } else {
        const minOffset = Math.min(...offsets);
        const maxOffset = Math.max(...offsets);
        width = Math.max(0.4, maxOffset - minOffset) + 0.4;
        centerOffset = (maxOffset + minOffset) / 2;
        adjustedX = x + centerOffset;
    }

    const groupPosition = [
        adjustedX * gridScale,
        y * gridScale * -1,
        columnBaseZ + (height * gridScale) / 2 - 0.15,
    ];

    const groupRotation = [
        0,
        0,
        -(positionAngle) * (Math.PI / 180),
    ];

    return (
        <group position={groupPosition} rotation={groupRotation}>
            <mesh>
                <boxGeometry args={[width, 0.4, 0.4]} />
                <meshStandardMaterial color={defaultBaseColor} />
            </mesh>

            {lanterns.map((lantern, index) => {
                const luminaireIndex = luminaires.indexOf(lantern.luminaireId);
                const resolvedColor = luminaireIndex !== -1 && colorList[luminaireIndex]
                    ? colorList[luminaireIndex]
                    : defaultBaseColor;

                const width = getOutreachWidth(lantern);

                return (
                    <mesh
                        key={index}
                        position={[
                            ((lantern.offset ?? 0) - centerOffset) * gridScale,
                            (width * gridScale) / 2,
                            -0.1,
                        ]}
                        rotation={[0, 0, -Math.PI / 2]}
                    >
                        <boxGeometry
                            args={[width * gridScale, 0.2 * gridScale, 0.2 * gridScale]}
                        />
                        <meshStandardMaterial color={resolvedColor === '#212529' ? defaultBaseColor : resolvedColor} />
                    </mesh>
                );
            })}
        </group>
    );
};

export default MastWallNone;
